import { render, staticRenderFns } from "./NcmSuggestion.vue?vue&type=template&id=2df93d4b"
import script from "./NcmSuggestion.vue?vue&type=script&lang=js"
export * from "./NcmSuggestion.vue?vue&type=script&lang=js"
import style0 from "./NcmSuggestion.vue?vue&type=style&index=0&id=2df93d4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports